import * as yup from 'yup';

export const emailSchema = yup
  .string()
  .email('*is not valid')
  .required('*is required')
  .label('email');

export const passwordSchema = yup
  .string()
  .matches(/\w*[a-z]\w*/, '*must have a lowercase letter')
  .matches(/\w*[A-Z]\w*/, '*must have a uppercase letter')
  .matches(/\d/, '*must have a digit')
  .matches(/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/, '*must have a special symbol')
  .min(8, ({ min }) => `*must be at least ${min} symbols`)
  .required('*is required')
  .label('password');

export const passwordConfirmSchema = yup
  .string()
  .oneOf([yup.ref('password')], '*password do not match')
  .required('*is required')
  .label('confirm password');
